import { Input } from '@trackman/web-shared-components';
import { observer } from 'mobx-react-lite';
import { useCallback } from 'react';
import { useStores } from 'index';
import { videoUrlValidator } from 'utilities/urlValidators';

type Props = {
  setSaveButtonDisabled: (value: boolean) => void;
};

export const LearningMaterialsVideo = observer(({ setSaveButtonDisabled }: Props) => {
  const lms = useStores().learningMaterialStore;

  const handleOnChange = useCallback(
    (newValue: string) => {
      setSaveButtonDisabled(false);
      if (videoUrlValidator(newValue) || newValue === '') {
        setSaveButtonDisabled(true);
      }
      lms.learningMaterial.youTubeKey = newValue;
    },
    [lms.learningMaterial, setSaveButtonDisabled]
  );

  return (
    <div className='video-settings-wrapper'>
      <Input
        label='YouTube video ID'
        value={lms.learningMaterial.youTubeKey ?? ''}
        error={!lms.learningMaterial.youTubeKey}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => handleOnChange(e.currentTarget.value)}
        hint={
          lms.learningMaterial.youTubeKey ? (
            <span>
              Please add only ID of the video, you can find it in the YouTube link eg. https://www.youtube.com/watch?v=
              <strong>xZoMV_ap4s4</strong>
            </span>
          ) : (
            'Please add video ID or change learning material type.'
          )
        }
      />
    </div>
  );
});

export default LearningMaterialsVideo;
